module.exports = __webpack_public_path__ + "static/banner-f700dc32dc55b031332fd161ba4cdc81.png";